import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@material-ui/core'
import React, { useState } from 'react'
import { debitoCompletoLineasPrestaciones } from '../../../../../actions/liquidaciones/liquidaciones';
import { useDispatch } from 'react-redux';

export const ModalNotaDebitos = (props) => {

    const { open, closeModal, comprobanteSeleccionado } = props;
    const dispatch = useDispatch();

    const [comentario, setComentario] = useState('');

    const carMin = 10;
    const carMax = 500;

    const [error, setError] =
        useState((((!comentario || comentario?.length < carMin)) || comentario?.length > carMax) ? true : false);


    const onChangeTextAreaHandler = (e) => {
        const hayError =
            e?.target?.value?.length < carMin || e?.target?.value?.length === carMax;
        setError(hayError);
        if (e?.target?.value?.length < carMax) {
            setComentario(e.target.value);
        }
    };


    const generarDebitos = () => {
        dispatch(debitoCompletoLineasPrestaciones(comprobanteSeleccionado?.idComprobante, comentario))
        closeModal();
    }

console.log(comentario)
    return (
        <Dialog
            fullWidth
            open={open}
            maxWidth={'md'}
            onClose={closeModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{`Agregar comentario`}</DialogTitle>
            <DialogContent>
                <Grid
                    container
                    spacing={2}
                    style={{ width: "60%", margin: "auto", marginBottom: 25 }}
                >
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            multiline
                            rows={4}
                            label="Comentario"
                            name="comentario"
                            value={comentario ?? ''}
                            onChange={onChangeTextAreaHandler}
                            error={error}
                            helperText={error && `Este campo es requerido con un mínimo de ${carMin} caracteres y un máximo de ${carMax}`}
                        />
                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <Grid container justify="center" style={{ marginBottom: 10 }}>
                    <Grid item xs={4}>
                        <Button
                            style={{ marginLeft: '15%' }}
                            onClick={closeModal}
                            variant="contained"
                            color="primary"
                        >
                            Cerrar
                        </Button>
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: 'right' }}>
                        <Button
                            color="primary"
                            variant="contained"
                            style={{ marginRight: '15%' }}
                            onClick={generarDebitos}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}
